<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home-page']" titlePrefix="Buzzronic - Trusted Ad Marketplace"
    metaDescription="A trusted ad marketplace designed to boost reach and revenue. Simplify ad trading with secure technology and high-quality inventory worldwide.">

    <div class="banner-section">
      <div class="banner-section__content">
        <h1 class="banner-section__title">Start your advertising and marketing journey</h1>
        <p class="banner-section__subtitle">Streamline your campaigns and maximize results with our
          powerful platform.</p>
        <div class="banner-section__cta" @click="scrollToContact">CONTACT <img src="@/assets/banner-contact-arrow.svg"
            alt=">" /></div>
      </div>
      <div class="banner-section__image">
        <img v-if="deviceType === 'mobile'" src="@/assets/banner-m.png" alt="Advertising Journey" />
        <img v-else src="@/assets/banner.png" alt="Advertising Journey" />
      </div>
    </div>

    <div class="services-section">
      <h2 class="services-section__title">Our Services</h2>
      <p class="services-section__subtitle">We provide high-quality advertising resources to help
        advertisers scale their campaigns and maximize returns.</p>
      <div class="services-section__cards">
        <div class="service-card service-card--green">
          <img src="@/assets/service-1.svg" alt="Global Ad Network" />
          <h3>High-Quality Global Ad Network</h3>
          <p>Reach targeted audiences across 180+ countries with diverse ad formats, including
            display, video, and push notifications. Our network ensures brand-safe placements, wide
            coverage, and performance-driven results.</p>
        </div>
        <div class="service-card service-card--blue">
          <img src="@/assets/service-2.svg" alt="Analytics and Optimization" />
          <h3>Smart Analytics & Campaign Optimization</h3>
          <p>Monitor campaigns in real time with advanced analytics, AI-powered bid adjustments, and
            anti-fraud measures. Track clicks, impressions, and conversions to maximize ROI with
            precision.</p>
        </div>
        <div class="service-card service-card--red">
          <img src="@/assets/service-3.svg" alt="Personalized Solutions" />
          <h3>Personalized Solutions & Expert Support</h3>
          <p>Benefit from dedicated account management, custom campaign strategies, and seamless API
            integration. Whether you’re an advertiser or publisher, we provide solutions tailored to
            your objectives.</p>
        </div>
      </div>
    </div>

    <div class="story-section">
      <div class="story-section__content">
        <h2 class="story-section__title">Our Story</h2>
        <h3 class="story-section__heading">We believe in the power of performance-driven
          advertising.</h3>
      </div>
      <div class="story-swich-content">
        <div class="story-section__left">
          <img src="@/assets/story-1.png" alt="Our Story Image 1"
            class="story-section__image--main">
        </div>
        <div class="story-section__right">
          <div class="story-section__right-images">
            <img src="@/assets/story-2.png" alt="Our Story Image 2"
              class="story-section__image--top">
            <img src="@/assets/story-3.png" alt="Our Story Image 3"
              class="story-section__image--bottom">
          </div>
          <div class="story-section__content">
            <p class="story-section__text">
              Founded by a team of digital marketing veterans, we’ve grown from a small startup into
              a
              trusted global network. What sets us apart is our hands-on expertise, cutting-edge
              technology, and commitment to fair partnerships. Whether you’re an advertiser looking
              for
              high-converting traffic or a publisher seeking premium offers, we’re here to make your
              journey seamless and profitable.
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="stats-section">
      <div class="stat">
        <p class="stat__number">50+</p>
        <p class="stat__description">Countries Served – Running high-performance campaigns across
          North America, Europe.</p>
      </div>
      <div class="stat">
        <p class="stat__number">95%</p>
        <p class="stat__description">Client Retention Rate – Proof of our focus on long-term
          partnerships over quick wins.</p>
      </div>
      <div class="stat">
        <p class="stat__number">1,000+</p>
        <p class="stat__description">Direct Advertisers - Trusted by agencies worldwide to deliver
          performance-driven campaigns.</p>
      </div>
    </div>

    <div class="why-choose-us-section">
      <h2 class="why-choose-us-section__title">Why Choose Us</h2>
      <h3 class="why-choose-us-section__heading">We don’t just drive traffic — we build lasting
        growth for advertisers and publishers.</h3>
      <div class="why-choose-us-section__cards">
        <div class="why-card">
          <div class="why-card__icon icon-1">
            <img src="@/assets/why-icon-1.svg" alt="Performance-Driven Results">
          </div>
          <div class="why-card__content">
            <h4>Performance-Driven Results</h4>
            <p>Our data-optimized campaigns consistently deliver above-industry averages, with
              transparent tracking you can trust.</p>
          </div>
        </div>
        <div class="why-card">
          <div class="why-card__icon icon-2">
            <img src="@/assets/why-icon-2.svg" alt="Global Reach, Local Expertise">
          </div>
          <div class="why-card__content">
            <h4>Global Reach, Local Expertise</h4>
            <p>Access premium traffic in 50+ countries while benefiting from our regional
              optimization strategies.</p>
          </div>
        </div>
        <div class="why-card">
          <div class="why-card__icon icon-3">
            <img src="@/assets/why-icon-3.svg" alt="Future-Proof Technology">
          </div>
          <div class="why-card__content">
            <h4>Future-Proof Technology</h4>
            <p>AI-powered bidding, real-time fraud prevention, and automated scaling tools keep you
              ahead of the curve.</p>
          </div>
        </div>
        <div class="why-card">
          <div class="why-card__icon icon-4">
            <img src="@/assets/why-icon-4.svg" alt="Partnership-First Approach">
          </div>
          <div class="why-card__content">
            <h4>Partnership-First Approach</h4>
            <p>Get dedicated account managers and strategic guidance – we succeed only when you do.
            </p>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common],
  data () {
    return {

    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  methods: {
    scrollToSection (hash) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    scrollToContact () {
      const contactElement = document.getElementById('contact');
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

  }
};
</script>

